<template>
  <b-container>

    <!-- Landing -->
    <b-container v-if="!site && !currentSignIn.site">
      <b-row class="site-info flex-column">
        <b-col class="mt-3 mb-3 section-alert-red">
          <p>Please use this App to sign in and out of site of any Schick Operational Site.</p>
          <p>Before you enter a site, you must agree to all the specific conditions and acknowledge the hazards and
            potential risks.</p>
        </b-col>
        <b-col class="mb-3 text-center" v-if="!visitor">
          <b-button class="display-flex align-items-center justify-content-center user-sign-in-btn sign-in-btn"
            @click="$router.push('/home')">
            <span class="mr-2">Schick Staff Click Here to Sign In</span>
            <b-icon icon="box-arrow-in-right"></b-icon>
          </b-button>
        </b-col>
        <b-col class="mb-3 text-center" v-if="!visitor">
          <b-button class="display-flex align-items-center justify-content-center visitor-sign-in-btn sign-in-btn"
            v-if="canLogInAsVisitor" @click="initiateVisitorLogin">
            <span class="mr-2">I am a visitor</span>
            <VisitorButtonIcon />
          </b-button>
          <p v-if="!canLogInAsVisitor" class="cantLogInAsVisitor">
            All Visitors to Site must sign in using the Schick QR Code
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- Visitor, at site, not signed in. -->
    <!-- <b-container v-if="site && !justSignedOut && !currentAction && !currentSignIn.site">
      <b-row class="mt-4">
        <b-col>Welcome to {{site.name}}.  What would you like to do?</b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex align-items-right justify-content-center pt-4 pb-2">
          <b-button variant="primary" @click="currentAction='signinme'; justSignedOut=false;" class="ml-3" v-if="!justSignedOut">Sign In</b-button>
          <b-button variant="primary" @click="currentAction='signout'; justSignedOut=false;" class="ml-3" v-if="!justSignedOut">Sign Out</b-button>
        </b-col>
      </b-row>
    </b-container> -->

    <!--! This is the Sign out START-->
    <!-- <b-container v-if="currentAction === 'signouts'"> -->
    <!-- <b-button v-on:click="multiPubSignIns()" class="mt-3" variant="primary">Show sign outs</b-button> -->
    <!--! Visitor Sign outs -->
    <!-- <b-container class="section-content-container">
        <div class="section-content-container mt-3">
          <b-row class="section-title justify-content-center">
            <b-row class="align-content-center">
              <h3 v-if="signIns.length > 0">Visitor Register: {{site.name}}</h3>
              <h3 v-else>No Visitors in {{site.name}}</h3>
            </b-row>
          </b-row>
        </div>
        <div>
          <b-col v-for="(signIn, index) in signIns" v-bind:key="index" class="section-content sign-in-register-content mt-3">
            <b-row class="align-items-center d-flex justify-content-between">
              <b-col class="container-size">
                <p class="name">{{signIn.name}}</p>
                <p>{{signIn.company}}</p>
              </b-col>
              <div>
                <p>{{signIn.phoneNumber}}</p>
              </div>
              <div>
                <b-button v-on:click="publicSignOuts(index)" class="btn btn-danger" variant="primary">Sign Out</b-button>
              </div>
            </b-row>
          </b-col>
        </div>
        <div class="mt-5">
          <b-button v-on:click="backButton()" class="ml-3" variant="primary">Back</b-button>
        </div>
      </b-container>
    </b-container> -->
    <!--! This is the Sign out END-->
    <!--! This is the MultiSign intermediate page START-->
    <!-- <b-container v-if="currentAction === 'signmultiland'">
      <b-row>
        <b-button variant="primary" @click="currentAction='signinus'; currentSignIn.site=false; commonSignInComplete=false;" class="mr-3">Sign More</b-button>
        <b-button variant="primary" @click="currentAction='signouts'; currentSignIn.site=false; commonSignInComplete=false;" class="mr-3">Sign Out</b-button>
      </b-row>
    </b-container> -->
    <!--! This is the MultiSign intermediate page END-->

    <!-- Site sign in initiated -->
    <b-container v-if="site && !currentSignIn.site && currentAction === 'signinme' || currentAction === 'signinus'">
      <b-row class="mt-4">
        <b-col class="pb-4">
          Please read the following site information and sign in.
        </b-col>
      </b-row>

      <b-row>
        <!-- <CommonSignIn :site="site" v-on:clear-site="clearSite" v-on:complete="completeCommonSignIn" /> -->
        <CommonSignIn :site="site" v-on:clear-site="clearSite" v-on:complete="signIn" />
      </b-row>
    </b-container>

    <!--! Multi-signin START-->
    <b-container v-if="siteId && site && currentAction === 'signinus' && commonSignInComplete">
      <b-col class="mt-4 mb-3 pl-0">
        Please Enter Details Below:
      </b-col>
      <b-form @submit="multiResponse" class="section-content-form">
        Your name: <b-form-input v-model="responses.name" :state="(responses.name || '').length >= 5" required
          class="mb-3 mt-1" />
        Company: <b-form-input v-model="responses.company" :state="(responses.company || '').length >= 2" required
          class="mb-3 mt-1" />
        Contact Mobile/Phone Number: <b-form-input v-model="responses.phoneNumber"
          :state="(responses.phoneNumber || '').length >= 7" required class="mb-3 mt-1" />
        E-Mail Address: <b-form-input v-model="responses.emailAddress" :state="(responses.emailAddress || '').length >= 5"
          required class="mb-3 mt-1" />
        Who are you visiting on site?: <b-form-input v-model="responses.visiting"
          :state="(responses.visiting || '').length >= 2" required class="mb-3 mt-1" />
        <br />
        <p class="pb-2">
          I agree to the conditions of this Hazard ID and consent that my name, location and contact details are recorded
          as part of the Schick site sign-in process.
        </p>
        <br />
        <b-form-checkbox class="mb-2" v-model="rememberme" value="true" unchecked-value="false">Remember my
          details</b-form-checkbox>
        <vue-recaptcha ref="recaptcha2" sitekey="6Lcd8fYUAAAAAB8pzpJhKcr6gNQLUqGG8WrjplYT" :loadRecaptchaScript="true"
          @verify="verifyRecaptcha" />
        <b-row>
          <b-button type="submit" value="Submit" class="mt-3" variant="primary" :disabled="!recaptchaToken">Add
            User</b-button>
        </b-row>
      </b-form>
    </b-container>
    <!--! Multi-signin END-->

    <!-- Signed in to site -->
    <!-- <b-container v-if="siteId && site && currentAction === 'signinme' && commonSignInComplete"> -->
    <b-container v-if="site && !justSignedOut && !currentAction && !currentSignIn.site">
      <b-row class="section-alert-dark">
        <p class="text-dark"><strong>IN AN EMERGENCY DIAL 111:</strong> State your name, location, number of people involved, if chemicals
          involved, significant hazards, your contact details.</p>
      </b-row>

      <div class="site-info">
        <b-row class="section-content-container">
          <b-col class="section-content">
            <b-col class="mt-4 mb-3 pl-0">
              Please Enter Details Below:
            </b-col>
            <!-- <b-form @submit="signIn" class="section-content-form"> -->
            <b-form class="section-content-form">
              Your name: <b-form-input v-model="responses.name" :state="(responses.name || '').length >= 5" required
                class="mb-3 mt-1" />
              Company: <b-form-input v-model="responses.company" :state="(responses.company || '').length >= 2" required
                class="mb-3 mt-1" />
              Contact Mobile/Phone Number: <b-form-input v-model="responses.phoneNumber"
                :state="(responses.phoneNumber || '').length >= 7" required class="mb-3 mt-1" />
              E-Mail Address: <b-form-input v-model="responses.emailAddress"
                :state="(responses.emailAddress || '').length >= 5" required class="mb-3 mt-1" />
              Who are you visiting on site?: <b-form-input v-model="responses.visiting"
                :state="(responses.visiting || '').length >= 2" required class="mb-3 mt-1" />
              <br />
              <p class="pb-2">
                I agree to the conditions of this Hazard ID and consent that my name, location and contact details are
                recorded as part of the Schick site sign-in process.
              </p>
              <br />
              <b-form-checkbox class="mb-2" v-model="rememberme" value="true" unchecked-value="false">Remember my
                details</b-form-checkbox>
              <vue-recaptcha ref="recaptcha2" sitekey="6Lcd8fYUAAAAAB8pzpJhKcr6gNQLUqGG8WrjplYT"
                :loadRecaptchaScript="true" @verify="verifyRecaptcha"/>
              <!-- <b-button class="mt-3" type="submit" variant="primary" :disabled="!recaptchaToken">Sign In</b-button> -->
            </b-form>
            <!--! Back and Next Button -->
            <div id="next-btn-wrapper">
              <b-row ref="next" class="container section-alert-dark next-btn-container justify-content-between py-2 px-3">
                <!-- <b-button variant="secondary" @click="dispatch('BACK')" class="w-50 mr-1 ml-n1"> -->
                <!-- <b-button class="w-50 mr-1 ml-n1" variant="secondary" @click="backHomePage"> -->
                <b-button class="w-50 mr-1 ml-n1" variant="secondary" @click="backHomePage">
                  <font-awesome-icon icon="arrow-circle-left" size="lg" fixedWidth class="icon" /> Back
                </b-button>
                <!-- <b-button class="w-50 ml-1 mr-n1" type="submit" variant="primary" :disabled="!recaptchaToken"> -->
                <b-button class="w-50 ml-1 mr-n1" :variant="isNextButtonDisabled ? 'secondary' : 'success'"
                  @click="currentAction = 'signinme'; justSignedOut = false;" :disabled="isNextButtonDisabled">
                  Next <font-awesome-icon icon="arrow-circle-right" size="lg" fixedWidth class="icon" />
                </b-button>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <!--TODO Add a && condition for next button and load each user below-->
    <b-container v-if="currentSignIn && currentSignIn.site">
      <b-row class="mt-4">
        <b-col>
          You are currently signed in at {{ ((currentSignIn || {}).site || {}).name }}
        </b-col>
      </b-row>
    </b-container>

    <!-- Initiated Sign out -->
    <b-container v-if="(currentSignIn && currentSignIn.site) || (site && currentAction === 'signout')">
      <b-row class="flex-column pt-4">
        <b-col>
          Sign out below:
        </b-col>
        <b-col class="mb-2">
          <b-form @submit="signOut">
            <span v-if="!currentSignIn.name">Your name: <b-form-input v-model="newSignOut.name"
                :state="(newSignOut.name || '').length >= 5" required /></span>
            <span v-if="!currentSignIn.company">Company: <b-form-input v-model="newSignOut.company"
                :state="(newSignOut.company || '').length >= 2" required /></span>
            <span v-if="!currentSignIn.phoneNumber">Contact Mobile/Phone Number: <b-form-input
                v-model="newSignOut.phoneNumber" :state="(newSignOut.phoneNumber || '').length >= 7" required /></span>
            <span v-if="!currentSignIn.emailAddress">E-Mail Address: <b-form-input v-model="newSignOut.emailAddress"
                :state="(newSignOut.emailAddress || '').length >= 5" required /></span>
            <span v-if="!currentSignIn.visiting">Who were you visiting on site?: <b-form-input
                v-model="newSignOut.visiting" :state="(newSignOut.visiting || '').length >= 2" required /></span>
            <b-form-checkbox v-model="rememberme" value="true" unchecked-value="false" v-if="!currentSignIn.name">Remember
              my details</b-form-checkbox>
            <br />
            <!-- <vue-recaptcha ref="recaptcha2" sitekey="6Lcd8fYUAAAAAB8pzpJhKcr6gNQLUqGG8WrjplYT" :loadRecaptchaScript="true" @verify="verifyRecaptcha"/> -->
            <!-- <b-button class="mt-3" type="submit" variant="primary" :disabled="!recaptchaToken">Sign Out</b-button> -->
            <b-button class="mt-3" type="submit" variant="primary">Sign Out</b-button>
            <!-- <b-button variant="primary" @click="currentAction='signinus'; currentSignIn.site=false; commonSignInComplete=false;" class="mr-3">Sign More</b-button> -->
            <!-- <b-button variant="primary" @click="currentAction='signinus'; currentSignIn.site=false; commonSignInComplete=false; justSignedOut=false;" class="mr-3">Sign More</b-button> -->
            <!-- <b-button variant="primary" @click="currentAction='signinus'; currentSignIn.site=false; commonSignInComplete=false;" class="mr-3">Sign More</b-button> -->
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <!-- Just Signed Out. -->
    <!-- <b-container v-if="justSignedOut" class="mt-2">
      <b-row class="mt-4">
        <b-col><b>You have signed out of {{ site.name }}</b></b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-button variant="primary" @click="currentAction = 'signinme'; justSignedOut = false;" class="mr-3">Sign
            In</b-button>
        </b-col>
      </b-row>
    </b-container> -->

  </b-container>
</template>

<script>
import {
  getPublicSite,
  publicSignIn,
  publicSignOut,
  getPublicSignIns,
  getSites,
  getSite,
} from '@/lib/api';
import moment from 'moment-timezone';
import { EventBus } from '@/lib/event-bus';
import VueRecaptcha from 'vue-recaptcha';
import CommonSignIn from '@/components/siteParts/CommonSignIn.vue';
import { setStorageItem, getStorageItem, clearStorageItem } from '@/lib/local-storage';
import { BIcon } from 'bootstrap-vue';
import VisitorButtonIcon from '@/components/VisitorButtonIcon.vue';
// import moment from 'moment-timezone';
/** OK so this one requires an explanation.  There are several scenarios.
 * 1.  You're here for the first time.  In this case, you need to confirm you're a person.
 * Then you can either sign in, sign out (because you're on a different device).
 * 2.  You're already signed in and we have a record of it.  Cool beans, please sign out.
 * 3.  You're not signed in.  Please sign in.
 * There are quite a few different scenarios so lots of booleans sitting around!
 */

export default {
  name: 'SignIn',
  components: {
    CommonSignIn,
    VueRecaptcha,
    BIcon,
    // BIconBoxArrowInRight,
    VisitorButtonIcon,
  },
  data() {
    return {
      gettingLocation: false,
      loading: true,
      siteId: null,
      site: null,
      responses: { covid19: {} },
      recaptchaToken: null,
      currentSignIn: {},
      newSignOut: {},
      signingOut: false,
      justSignedOut: false,
      currentAction: null,
      rememberme: false,
      visitor: false,
      commonSignInComplete: false,
      multiSign: [],
      signIns: [],
      today: new Date(),
      date: '',
      endDate: '',
      eligibleSites: [],
    };
  },
  watch: {
    visitor(newValue, oldValue) {
      if (!oldValue && newValue) this.loadSite();
    },
    async $route(to, from) {
      if (to.params.siteId !== from.params.siteId) {
        // update sign ins
        this.site = await getSite(this.siteId);
        await this.loadSignIns();
      }
    },
    async date(to, from) {
      if (to !== from) {
        await this.loadSignIns();
      }
    },
    async endDate(to, from) {
      if (to !== from) {
        await this.loadSignIns();
      }
    },
  },
  computed: {
    // ! New computed method
    isNextButtonDisabled() {
      // return !this.recaptchaToken || !this.responses.name || !this.responses.company || !this.responses.phoneNumber || !this.responses.emailAddress || !this.responses.visiting || (this.responses.visiting).length <= 2;
      // return !this.recaptchaToken || (this.responses.name).length < 5 || (this.responses.company).length < 2 || (this.responses.phoneNumber).length < 7 || (this.responses.emailAddress).length < 5 || (this.responses.visiting).length < 2;
      return (
        !this.recaptchaToken
        || (this.responses.name ? this.responses.name.length < 5 : true)
        || (this.responses.company ? this.responses.company.length < 2 : true)
        || (this.responses.phoneNumber ? this.responses.phoneNumber.length < 7 : true)
        || (this.responses.emailAddress ? this.responses.emailAddress.length < 5 : true)
        || (this.responses.visiting ? this.responses.visiting.length < 2 : true)
      );
    },
    signInDisabled() {
      return !(this.responses.allCriticalRisks === 'Yes'
        && this.responses.standardRisks === 'Yes'
        && this.covid19OKrr
        && this.covid19Completed);
    },
    covid19OK() {
      const covid19Responses = this.responses.covid19;
      if (Object.keys(covid19Responses).length !== 4) return false;
      return Object.values(covid19Responses).reduce((accumulator, value) => accumulator && value === 'Agree', true);
    },
    covid19Completed() {
      const covid19Responses = this.responses.covid19;
      if (Object.keys(covid19Responses).length !== 4) return false;
      return Object.values(covid19Responses).reduce((accumulator, value) => accumulator && !!value, true);
    },
    canLogInAsVisitor() {
      return !!this.$route.query.siteId && !!this.$route.query.siteLongId;
    },
  },
  methods: {
    async signInUpdate() {
      this.signIns = await getPublicSignIns(this.site.id, this.site.longid);
      this.signIns = this.signIns.filter((filteredSignIn) => filteredSignIn.signOutTime == null && filteredSignIn.visiting !== 'N/A - Internal Staff');
    },
    backButton() {
      this.currentAction = null;
      this.justSignedOut = false;
    },
    async multiPubSignIns() {
      this.signInUpdate();
      this.currentAction = 'signouts';
      this.justSignedOut = false;
    },
    timeFormat(dateTime) {
      if (!dateTime) {
        return '';
      }
      return moment(dateTime).tz('Pacific/Auckland').format('h:mm A');
    },
    signOutTimeFormat(value, key, item) {
      // sign out time has been set
      if (value) { return this.timeFormat(value); }

      // we are still on sign in day.
      const today = moment(new Date()).tz('Pacific/Auckland');
      const signInTime = moment(item.signInTime).tz('Pacific/Auckland');
      if (signInTime.isSame(today, 'day')) {
        return '';
      }

      // signin was in the past, so display auto logged out at midnight of signin day.
      const signOutTime = moment(item.signInTime).tz('Pacific/Auckland').endOf('day');
      return this.timeFormat(signOutTime);
    },
    visitingFormat(visiting) {
      if (visiting.startsWith('N/A')) {
        return '';
      }

      return visiting;
    },
    // do the actual sign in.
    async multiResponse(event) {
      event.preventDefault();
      EventBus.$emit('showLoader');
      this.loading = true;

      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }
      await publicSignIn(this.site.id,
        this.site.longid,
        latLng,
        this.responses.name,
        this.responses.company,
        this.responses.emailAddress,
        this.responses.visiting,
        this.responses.phoneNumber,
        JSON.stringify(this.responses),
        this.recaptchaToken);
      EventBus.$emit('triggerAlert', { type: 'success', message: 'Visitor has been signed in' });
      this.currentAction = null;
      this.currentSignIn.site = false;
      this.commonSignInComplete = false;
      window.scrollTo(0, 0);
      this.loading = false;
      EventBus.$emit('hideLoader');
    },
    async publicSignOuts(arrayIndex) {
      EventBus.$emit('showLoader');
      this.loading = true;
      // this.site2 = await getSite(this.selectedSite.siteId);
      // get location
      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }
      await publicSignOut(
        this.site.id,
        this.site.longid,
        this.signIns[arrayIndex].longid,
        latLng,
        this.signIns[arrayIndex].name,
        this.signIns[arrayIndex].company,
        this.signIns[arrayIndex].emailAddress,
        this.signIns[arrayIndex].visiting,
        this.signIns[arrayIndex].phoneNumber,
      );
      this.signInUpdate();
      EventBus.$emit('triggerAlert', { type: 'success', message: 'Visitor has been signed out' });
      this.loading = false;
      EventBus.$emit('hideLoader');
    },
    clearSite() {
      this.currentAction = null;
      this.recaptchaToken = null;
    },
    initiateVisitorLogin() {
      this.visitor = true;
      clearStorageItem('lastSiteId');
      EventBus.$emit('isCompact', true);
    },
    verifyRecaptcha(response) {
      this.recaptchaToken = response;
    },
    async loadSite() {
      EventBus.$emit('showLoader');
      this.recaptchaToken = null;
      try {
        this.site = await getPublicSite(this.$route.query.siteId, this.$route.query.siteLongId, this.recaptchaToken);
        if (!this.site) throw new Error();
        this.siteId = this.site.id;
      } catch (e) {
        EventBus.$emit('triggerAlert', {
          type: 'danger',
          message: 'Could not find site - please contact Site Contact',
        });
      }
      EventBus.$emit('hideLoader');
    },
    completeCommonSignIn(responses) {
      this.commonSignInComplete = true;
      this.responses = responses;
    },
    // async signIn(event) {
    async signIn() {
      // first of all stop a page reload
      // event.preventDefault();
      EventBus.$emit('showLoader');
      // THIS IS ADDED TO SHOW THE USER THAT HAS BEEN ADDED
      EventBus.$emit('triggerAlert', { type: 'success', message: 'User has been signed in' });
      // get the current location.
      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }

      // do the actual sign in.
      const signInResponse = await publicSignIn(this.site.id,
        this.site.longid,
        latLng,
        this.responses.name,
        this.responses.company,
        this.responses.emailAddress,
        this.responses.visiting,
        this.responses.phoneNumber,
        JSON.stringify(this.responses),
        this.recaptchaToken);

      // signed in or already signed in (by email address)
      if (signInResponse.status === 200 || signInResponse.status === 409) {
        let signIn;
        if (signInResponse.status === 409) {
          EventBus.$emit('triggerAlert', {
            type: 'success',
            message: 'Already signed in',
          });
          signIn = {
            site: {
              name: this.site.name,
              id: this.site.id,
              longid: this.site.longid,
            },
          };
        } else {
          EventBus.$emit('triggerAlert', {
            type: 'success',
            message: 'Signed in',
          });
          signIn = signInResponse.data;
        }

        // save some state stuff.
        if (!this.initialSignedIn) {
          setStorageItem('lastSignIn', signIn);
          this.currentSignIn = signIn;
          this.newSignOut = {
            name: this.currentSignIn.name,
            company: this.currentSignIn.company,
            phoneNumber: this.currentSignIn.phoneNumber,
            emailAddress: this.currentSignIn.emailAddress,
            visiting: this.currentSignIn.visiting,
          };

          if (this.rememberme) {
            this.setRememberMe(
              this.currentSignIn.name,
              this.currentSignIn.company,
              this.currentSignIn.emailAddress,
              this.currentSignIn.phoneNumber,
            );
            this.loadRememberMe();
          } else {
            clearStorageItem('rememberMe');
          }
          this.initialSignedIn = true;
        }

        this.justSignedOut = false;
        this.currentAction = null;
        EventBus.$emit('triggerAlert', {
          type: 'success',
          message: 'Thanks for signing in',
        });
      } else {
        // finish up.
        EventBus.$emit('triggerAlert', {
          type: 'danger',
          message: 'Could not sign in, please contact Site Contact',
        });
      }
      EventBus.$emit('hideLoader');
      EventBus.$emit('isCompact', false);
    },
    setRememberMe(name, company, emailAddress, phoneNumber) {
      setStorageItem('rememberMe', {
        name,
        emailAddress,
        phoneNumber,
        company,
      });
    },
    // New method
    async backHomePage() {
      // try {
      // this.currentSignIn = {};
      // this.responses = {};
      //! this.recaptchaToken = {};
      // this.currentAction = null;
      // this.commonSignInComplete = false;
      // this.visitor = false;
      // this.site = null;
      // clearStorageItem('lastSignIn');
      //! this.clearSite();
      //! clearStorageItem('lastSiteId');
      //! EventBus.$emit('isCompact', true);
      window.location.reload();
      //   console.log('This works');
      //   console.log(this.recaptchaToken);
      // } catch (error) {
      //   console.error('An error occurred:', error);
      // }
    },
    async signOut(event) {
      // stop normal submission
      event.preventDefault();
      EventBus.$emit('showLoader');

      // get location
      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }

      // sign out.
      if (this.currentSignIn && this.currentSignIn.site) this.site = this.currentSignIn.site;

      const signOutResponse = await publicSignOut(
        ((this.currentSignIn || {}).site || this.site).id,
        ((this.currentSignIn || {}).site || this.site).longid,
        this.currentSignIn.longid,
        latLng,
        this.currentSignIn.name || this.newSignOut.name,
        this.currentSignIn.company || this.newSignOut.company,
        this.currentSignIn.emailAddress || this.newSignOut.emailAddress,
        this.currentSignIn.visiting || this.newSignOut.visiting,
        this.currentSignIn.phoneNumber || this.newSignOut.phoneNumber,
        // this.recaptchaToken, //Delete this??
      );

      // signed in or already signed in (by email address).
      // set some status.
      if (signOutResponse.status === 200) {
        if (this.rememberme) {
          this.setRememberMe(
            this.newSignOut.name || this.currentSignIn.name,
            this.newSignOut.company || this.currentSignIn.company,
            this.newSignOut.emailAddress || this.currentSignIn.emailAddress,
            this.newSignOut.phoneNumber || this.currentSignIn.phoneNumber,
          );
          this.loadRememberMe();
          this.newSignOut.visiting = '';
        } else {
          this.newSignOut = {};
          clearStorageItem('rememberMe');
        }
        clearStorageItem('lastSignIn');
        // this.currentSignIn = {};
        this.justSignedOut = true;
        // this.currentAction = null;
        this.backHomePage();
        EventBus.$emit('triggerAlert', {
          type: 'success',
          message: 'Thanks for signing out',
        });
      } else {
        // finish up.
        EventBus.$emit('triggerAlert', {
          type: 'danger',
          message: 'Could not sign out, please contact Site Contact',
        });
      }
      EventBus.$emit('hideLoader');
      this.commonSignInComplete = false;
    },
    loadRememberMe() {
      const rememberMeData = getStorageItem('rememberMe');
      if (rememberMeData) {
        this.rememberme = true;
        this.responses.name = rememberMeData.name;
        this.responses.company = rememberMeData.company;
        this.responses.emailAddress = rememberMeData.emailAddress;
        this.responses.phoneNumber = rememberMeData.phoneNumber;
        this.newSignOut.name = rememberMeData.name;
        this.newSignOut.company = rememberMeData.company;
        this.newSignOut.emailAddress = rememberMeData.emailAddress;
        this.newSignOut.phoneNumber = rememberMeData.phoneNumber;
      }
    },
  },
  async mounted() {
    // NEW
    // this.signIns = await getPublicSignIns(this.site.id, this.site.longid);
    // this.signIns = this.signIns.filter((filteredSignIn) => filteredSignIn.signOutTime == null && filteredSignIn.visiting !== 'N/A - Internal Staff');
    // -----------------------------------------------------------------------------------------------------------------------------------------------
    this.currentSignIn = getStorageItem('lastSignIn') || {};
    if (this.$route.query.siteId) setStorageItem('lastSiteId', this.$route.query.siteId);
    this.newSignOut = {
      name: this.currentSignIn.name,
      company: this.currentSignIn.company,
      phoneNumber: this.currentSignIn.phoneNumber,
      emailAddress: this.currentSignIn.emailAddress,
      visiting: this.currentSignIn.visiting,
    };
    this.loadRememberMe();
    this.siteId = this.$route.params.siteId;
    this.eligibleSites = (await getSites()).map((site) => ({ value: site.id, text: `${site.jobNumber} - ${site.name}` }));
    this.date = this.$route.query.date || moment().tz('Pacific/Auckland').format('YYYY-MM-DD');
    this.endDate = this.$route.query.date || moment().tz('Pacific/Auckland').format('YYYY-MM-DD');
    if (this.siteId) {
      this.site = await getSite(this.siteId);
    }
    await this.loadSignIns();
  },
};
</script>

<style>.cantLogInAsVisitor {
  margin: auto;
  margin-top: 1.7rem;
  width: 50%;
  font-weight: bold;
}

.container-size {
  flex-grow: 0.2 !important;
}</style>
